// extracted by mini-css-extract-plugin
export default {"bot-list":"BotList_bot-list__1upsU"};